<form
  #form="ngForm"
  novalidate
  class="flex flex-col gap-1"
>
  <nsp-calendar-input
    *nspVisible="
      offshoreReportStore.vm().isFieldVisible(tabId, sectionId, 'reportFrom')
    "
    [name]="'reportFrom'"
    [id]="'reportFrom'"
    label="Report From"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('reportFrom')"
    [readonly]="isFieldReadOnly('reportFrom')"
    [value]="store.reportDetails?.()?.reportFrom?.value"
    [ngModel]="store.reportDetails?.()?.reportFrom?.value"
  />
  <nsp-calendar-input
    *nspVisible="
      offshoreReportStore.vm().isFieldVisible(tabId, sectionId, 'reportTo')
    "
    [name]="'reportTo'"
    [id]="'reportTo'"
    label="Report To"
    [labelWidthPercentage]="33"
    [readonly]="isFieldReadOnly('reportTo')"
    [required]="isFieldRequired('reportTo')"
    [value]="store.reportDetails?.()?.reportTo?.value"
    [ngModel]="store.reportDetails?.()?.reportTo?.value"
    [min]="store.reportDetails?.()?.reportFrom?.value"
  />
  <nsp-calendar-input
    *nspVisible="
      offshoreReportStore
        .vm()
        .isFieldVisible(tabId, sectionId, 'reportCreation')
    "
    [name]="'reportCreation'"
    [id]="'reportCreation'"
    label="Report Creation"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('reportCreation')"
    [readonly]="isFieldReadOnly('reportCreation')"
    [value]="store.reportDetails?.()?.reportCreation?.value"
    [ngModel]="store.reportDetails?.()?.reportCreation?.value"
  />
  <nsp-select-input
    *nspVisible="
      offshoreReportStore.vm().isFieldVisible(tabId, sectionId, 'timezone')
    "
    [name]="'timezone'"
    [id]="'timezone'"
    label="Timezone"
    [options]="timezoneOptions"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('timezone')"
    [readonly]="isFieldReadOnly('timezone')"
    [value]="store.reportDetails?.()?.timezone?.value"
    [ngModel]="store.reportDetails?.()?.timezone?.value"
  />
  <nsp-select-input
    *nspVisible="
      offshoreReportStore
        .vm()
        .isFieldVisible(tabId, sectionId, 'previousTimezone')
    "
    [name]="'previousTimezone'"
    [id]="'previousTimezone'"
    label="Previous Timezone"
    [options]="timezoneOptions"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('previousTimezone')"
    [readonly]="isFieldReadOnly('previousTimezone')"
    [value]="store.reportDetails?.()?.previousTimezone?.value"
    [ngModel]="store.reportDetails?.()?.previousTimezone?.value"
  />
  <nsp-number-input
    *nspVisible="
      offshoreReportStore.vm().isFieldVisible(tabId, sectionId, 'reportPeriod')
    "
    [name]="'reportPeriod'"
    [id]="'reportPeriod'"
    label="Report Period"
    [unit]="'Hours'"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('reportPeriod')"
    [readonly]="isFieldReadOnly('reportPeriod')"
    [value]="store.vm().reportPeriod('reportDetails')"
    [ngModel]="store.vm().reportPeriod('reportDetails')"
  />
</form>
